import Vue from "vue";
import Vuex from "vuex"

import crmModule         from "../crm/store";
import { incModule }     from "../inc/store";
import siteModule        from "../msd/unit/store/site";
import coreModule        from "./store/index";
import imbModule         from "../inb/store";
import repModule         from "@/modules/rep/store";
import dmsModule         from "@/modules/dms/common/store";
import auditModule       from "@/modules/audit/store";
import dispositionModule from "@/modules/dis/store";

Vue.use(Vuex)

export const store = new Vuex.Store ({
    modules: {
        crmModule,
        incModule,
        siteModule,
        coreModule,
        imbModule,
        repModule,
        dmsModule,
        auditModule,
        dispositionModule
    }
});
